import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { publicRoutes } from "./router.link";
import Feature from "../feature";
import Checkout from "../Courses/course-checkout/Checkout";
import StudentDashboard from "../student/StudentDashboard";
import ProtectedRoute from "../../protected/ProtectedRoute";
import RoleProtectedRoute from "../../protected/RoleProtectedRoute";
import AdminDashboard from "../admin/AdminDashboard";
import MentorDashboard from "../mentor/MentorDashboard";
import EmployeeDashboard from "../employee/EmployeeDashboard";
import ManageStudents from "../admin/ManageStudents";
import EditStudent from "../admin/EditStudent";
import EditCourse from "../admin/EditCourse";
import CreateCourse from "../admin/CreateCourse";
import ManageCourses from "../admin/ManageCourses";
import ManageBatches from "../admin/ManageBatches";
import CreateBatch from "../admin/CreateBatch";
import AdminEnrollments from "../admin/AdminEnrollments";
import StudentCourses from "../student/StudentCourses";
import ManageAppointments from "../admin/ManageAppointments";
import EditBatch from "../admin/EditBatch";
import MentorBatches from "../mentor/MentorBatches";
import AdminManageQuizzes from "../admin/AdminManageQuizzes";
import CreateQuizPage from "../quiz/CreateQuizPage";
import AddQuestionsPage from "../quiz/AddQuestionsPage";
import EditQuizPage from "../admin/EditQuizPage";
import AssignQuizPage from "../quiz/AssignQuizPage";
import StudentBatch from "../student/StudentBatch";
import AdminBatchQuizSummary from "../quiz/AdminBatchQuizSummary";
import MentorBatchQuizOverview from "../mentor/MentorManageQuiz";
import StudentAttendanceOverview from "../student/StudentAttendanceOverview";
import ChatApp from "../student/ChatApp";
import MentorBatchCourseProgress from "../mentor/MentorBatchCourseProgress";
import AdminPaymentManagement from "../admin/AdminPaymentManagement";
import DueInstallments from "../admin/DueInstallments";
import RequireActiveStudent from "../student/RequireActiveStudent";
import ManageAdminsMentors from "../admin/ManageAdminsMentors";
import FinancialDashboard from "../admin/FinancialDashboard";
import AdminStepManagement from "../admin/AdminStepManagement";
import StudentProgressDashboard from "../student/StudentProgressDashboard";
import MentorProgressDashboard from "../mentor/MentorProgressDashboard";
import AdminProgressDashboard from "../admin/AdminProgressDashboard";
import MentorRegisterPage from "../admin/MentorRegisterPage";
import ForgotPasswordPage from "../auth/login/ForgotPasswordPage";
import ResetPasswordPage from "../auth/login/ResetPasswordPage";
import LegacyRegister from "../auth/register/LegacyRegister";
import AdminLegacyPending from "../admin/AdminLegacyPending";
import RegistrationSuccess from "../auth/register/RegistrationSuccess";
import SchreibenPracticePage from "../student/SchreibenPracticePage";
import AdminWritingTasksPage from "../admin/AdminWritingTasksPage";
import CreateWritingTaskPage from "../admin/CreateWritingTaskPage";
import EditWritingTaskPage from "../admin/EditWritingTaskPage";
import AssignWritingTaskPage from "../admin/AssignWritingTaskPage";
import MentorWritingTasksPage from "../mentor/MentorWritingTasksPage";
import MentorAssignWritingTaskPage from "../mentor/MentorAssignWritingTaskPage";
import StudentMyWritingTasksPage from "../student/StudentMyWritingTasksPage";
import StudentWritingTaskPage from "../student/StudentWritingTaskPage";
import StudentQuiz from "../student/StudentQuiz";
import MentorBatchWritingTaskResultsPage from "../mentor/MentorBatchWritingTaskResultsPage";
import LoginPage from "../auth/login/LoginPage";
import EnrollmentConfirmation from "../Courses/course-checkout/EnrollmentConfirmation";
import AdminAttendanceOverview from "../admin/AdminAttendanceOverview";
import CourseRegulations from "../student/CourseRegulations";
import AdminRegulationReview from "../admin/AdminRegulationReview";
import CourseRegulationTemplates from "../admin/CourseRegulationTemplates";
import AusbildungApplicationTracking from "../student/AusbildungApplicationTracking";
import AdminAusbildungDashboard from "../admin/applicationtracker/AdminAusbildungDashboard";
import AdminHomeworkPage from "../admin/homework/AdminHomeworkPage";
import AdminCreateHomeworkPage from "../admin/homework/AdminCreateHomeworkPage";
import AdminEditHomeworkPage from "../admin/homework/AdminEditHomeworkPage";
import AdminAssignHomeworkPage from "../admin/homework/AdminAssignHomeworkPage";
import MentorHomeworkPage from "../mentor/homework/MentorHomeworkPage";
import MentorHomeworkViewPage from "../mentor/homework/MentorHomeworkViewPage";
import MentorAssignHomeworkPage from "../mentor/homework/MentorAssignHomeworkPage";
import StudentMyHomeworkPage from "../student/homework/StudentMyHomeworkPage";
import StudentHomeworkCompletePage from "../student/homework/StudentHomeworkCompletePage";
import StudentHomeworkSubmissionPage from "../student/homework/StudentHomeworkSubmissionPage";
import MentorManageQuiz from "../mentor/MentorManageQuiz";
import StudentVocabulary from "../student/StudentVocabulary";
import AdminVocabularyManagement from "../admin/vocab/Adminvocabularymanagement";
import AdminHomeworkViewPage from "../admin/homework/AdminHomeworkViewPage";

import AdminExamManagement from "../admin/exam/AdminExamManagement";
import AdminCreateExamSet from "../admin/exam/AdminCreateExamSet";
import AdminEditExamSet from "../admin/exam/AdminEditExamSet";
import AdminManageQuestions from "../admin/exam/AdminManageQuestions";
import AdminAssignExam from "../admin/exam/AdminAssignExam";
import AdminExamResults from "../admin/exam/AdminExamResults";
import AdminExamStatistics from "../admin/exam/AdminExamStatistics";
import AdminExamAssignments from "../admin/exam/AdminExamAssignments";
import AdminExamBuilder from "../admin/exam/AdminExamBuilder";
import MentorExamManagement from "../mentor/exam/MentorExamManagement";
import MentorGradeExam from "../mentor/exam/MentorGradeExam";
import MentorExamResults from "../mentor/exam/MentorExamResults";
import StudentMyExams from "../student/exam/StudentMyExams";
import StudentTakeExam from "../student/exam/StudentTakeExam";
import StudentExamResult from "../student/exam/StudentExamResult";
import AdminBatchGrading from "../admin/exam/AdminBatchGrading";
import AdminClassTestManagement from "../admin/classtest/AdminClassTestManagement";
import MentorClassTestManagement from "../mentor/classtest/MentorClassTestManagement";
import StudentClassTestPage from "../student/classtest/StudentClassTestPage";
import CoverLetterAccessManagement from "../admin/CoverLetterAccessManagement";
import CvBuilderAccessManagement from "../admin/CvBuilderAccessManagement";
import CoverLetterGenerator from "../student/CoverLetterGenerator";
import StudentCVBuilder from "../student/StudentCVBuilder";
import GradeConverter from "../student/GradeConverter";
import CVBuilderGuide from "../student/CVBuilderGuide";

// ✅ BLOG IMPORTS
import Blog from "../blog/Blog";
import BlogDetails from "../blog/BlogDetails";
import AdminBlogManagement from "../admin/blog/AdminBlogManagement";
import CreateEditBlog from "../admin/blog/CreateEditBlog";
import AdminCalendarManagement from "../admin/AdminCalendarManagement";
import AdminShadowingTasksPage from "../admin/shadowing/AdminShadowingTasksPage";
import CreateShadowingTaskPage from "../admin/shadowing/CreateShadowingTaskPage";
import EditShadowingTaskPage from "../admin/shadowing/EditShadowingTaskPage";
import AssignShadowingTaskPage from "../admin/shadowing/AssignShadowingTaskPage";
import StudentShadowingTaskPage from "../student/shadowing/StudentShadowingTaskPage";
import StudentMyShadowingTasksPage from "../student/shadowing/StudentMyShadowingTasksPage";
import ReviewShadowingSubmissionPage from "../admin/shadowing/ReviewShadowingSubmissionPage";
import MentorShadowingTasksPage from "../mentor/shadowing/MentorShadowingTasksPage";
import MentorAssignShadowingTaskPage from "../mentor/shadowing/MentorAssignShadowingTaskPage";
import MentorBatchShadowingTaskSummary from "../mentor/shadowing/MentorBatchShadowingTaskSummary";
import MentorReviewShadowingSubmissionPage from "../mentor/shadowing/MentorReviewShadowingSubmissionPage";
import AdminShadowingSubmissionsListPage from "../admin/shadowing/AdminShadowingSubmissionsListPage";
import MentorReviewShadowingSubmissionDetailPage from "../mentor/shadowing/MentorReviewShadowingSubmissionDetailPage";
import MonthlyVisits from "../admin/MonthlyVisits";
import AdminActivityReport from "../admin/AdminActivityReport";
import CourseLecturesLayout from "../admin/courseLectures/CourseLecturesLayout";
import StudentAudioPage from "../student/audio/StudentAudioPage";
import AdminAudioReviewPage from "../admin/audio/AdminAudioReviewPage";
import MentorAudioReviewPage from "../mentor/audio/MentorAudioReviewPage";
import AdminMentorTracker from "../admin/AdminMentorTracker";
import MentorTaskCheckinPage from "../mentor/MentorTaskCheckinPage";

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      {/* CRITICAL: Auth routes MUST come first before Feature wrapper */}
      {/* <Route path="/register" element={<RegisterPage />} /> */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* ✅ ADD ENROLLMENT CONFIRMATION ROUTE HERE - Must be protected */}
      <Route element={<ProtectedRoute />}>
        <Route
          path="/enrollment-confirmation"
          element={<EnrollmentConfirmation />}
        />
      </Route>

      {/* Legacy Registration - Also outside Feature */}
      <Route path="/legacy-register" element={<LegacyRegister />} />
      <Route path="/registration-success" element={<RegistrationSuccess />} />

      {/* Public Pages wrapped in Feature */}
      <Route element={<Feature />}>
        {publicRoutes
          .filter(
            (route) =>
              route.path !== "/register" &&
              route.path !== "/login" &&
              route.path !== "/forgot-password" &&
              route.path !== "/reset-password",
          )
          .map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}

        {/* ✅ BLOG PUBLIC ROUTES - Add these inside Feature wrapper */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
      </Route>

      {/* General Protected Pages (any authenticated user) */}
      <Route element={<ProtectedRoute />}>
        <Route path="/course/checkout" element={<Checkout />} />
      </Route>

      {/* STUDENT ROLE PROTECTED ROUTES */}
      <Route element={<RoleProtectedRoute allowedRoles={["STUDENT"]} />}>
        {/* Always accessible to students (active or inactive) */}
        <Route
          path="/student/student-dashboard"
          element={<StudentDashboard />}
        />
        <Route path="/student/my-courses" element={<StudentCourses />} />
        <Route
          path="/student/course-progress"
          element={<StudentProgressDashboard />}
        />
        <Route
          path="/student/course-regulations"
          element={<CourseRegulations />}
        />
        {/* ACTIVE STUDENT ONLY */}
        <Route
          path="/student/my-batch"
          element={
            <RequireActiveStudent>
              <StudentBatch />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/my-attendance"
          element={
            <RequireActiveStudent>
              <StudentAttendanceOverview />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/study-assistant"
          element={
            <RequireActiveStudent>
              <ChatApp />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/writing-practice"
          element={
            <RequireActiveStudent>
              <React.Suspense fallback={<div>Loading...</div>}>
                <SchreibenPracticePage />
              </React.Suspense>
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/my-writing-tasks"
          element={
            <RequireActiveStudent>
              <React.Suspense fallback={<div>Loading...</div>}>
                <StudentMyWritingTasksPage />
              </React.Suspense>
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/writing-task/:taskId"
          element={
            <RequireActiveStudent>
              <React.Suspense fallback={<div>Loading...</div>}>
                <StudentWritingTaskPage />
              </React.Suspense>
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/manage-quizzes"
          element={
            <RequireActiveStudent>
              <StudentQuiz />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/ausbildung-application-tracking"
          element={
            <RequireActiveStudent>
              <AusbildungApplicationTracking />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/my-homework"
          element={
            <RequireActiveStudent>
              <StudentMyHomeworkPage />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/homework/:homeworkId/complete"
          element={
            <RequireActiveStudent>
              <StudentHomeworkCompletePage />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/homework/:homeworkId/submission"
          element={
            <RequireActiveStudent>
              <StudentHomeworkSubmissionPage />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/vocabulary"
          element={
            <RequireActiveStudent>
              <StudentVocabulary />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/my-exams"
          element={
            <RequireActiveStudent>
              <StudentMyExams />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/exam/:assignmentId/take"
          element={
            <RequireActiveStudent>
              <StudentTakeExam />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/exam/:attemptId/result"
          element={
            <RequireActiveStudent>
              <StudentExamResult />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/my-class-tests"
          element={
            <RequireActiveStudent>
              <StudentClassTestPage />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/cover-letter-generator"
          element={
            <RequireActiveStudent>
              <CoverLetterGenerator />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/cv-builder"
          element={
            <RequireActiveStudent>
              <StudentCVBuilder />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/grade-converter"
          element={
            <RequireActiveStudent>
              <GradeConverter />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/cv-guide"
          element={
            <RequireActiveStudent>
              <CVBuilderGuide />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/shadowing-task/:taskId"
          element={
            <RequireActiveStudent>
              <StudentShadowingTaskPage />
            </RequireActiveStudent>
          }
        />

        <Route
          path="/student/my-shadowing-tasks"
          element={
            <RequireActiveStudent>
              <StudentMyShadowingTasksPage />
            </RequireActiveStudent>
          }
        />
        <Route
          path="/student/speaking-practice"
          element={
            <RequireActiveStudent>
              <StudentAudioPage />
            </RequireActiveStudent>
          }
        />
      </Route>

      {/* ADMIN ROLE PROTECTED ROUTES */}
      <Route element={<RoleProtectedRoute allowedRoles={["ADMIN"]} />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/manage-students" element={<ManageStudents />} />
        <Route path="/admin/edit-student/:id" element={<EditStudent />} />
        <Route path="/admin/manage-courses" element={<ManageCourses />} />
        <Route path="/admin/create-course" element={<CreateCourse />} />
        <Route path="/admin/edit-course/:id" element={<EditCourse />} />
        <Route path="/admin/manage-batches" element={<ManageBatches />} />
        <Route path="/admin/create-batch" element={<CreateBatch />} />
        <Route path="/admin/edit-batch/:id" element={<EditBatch />} />
        <Route
          path="/admin/manage-enrollments"
          element={<AdminEnrollments />}
        />
        <Route
          path="/admin/manage-appointments"
          element={<ManageAppointments />}
        />
        <Route path="/admin/manage-mentors" element={<ManageAdminsMentors />} />
        <Route path="/admin/manage-quizzes" element={<AdminManageQuizzes />} />
        <Route path="/admin/create-quiz" element={<CreateQuizPage />} />
        <Route
          path="/quiz/:quizId/add-questions"
          element={<AddQuestionsPage />}
        />
        <Route
          path="/admin/manage-quizzes/:quizId/edit"
          element={<EditQuizPage />}
        />
        <Route
          path="/admin/manage-quizzes/:quizId/assign"
          element={<AssignQuizPage />}
        />
        <Route
          path="/admin/batch/:batchId/quiz-results"
          element={<AdminBatchQuizSummary />}
        />
        <Route
          path="/admin/payment-management"
          element={<AdminPaymentManagement />}
        />
        <Route
          path="/admin/due-installments"
          element={<DueInstallments />}
        />
        <Route
          path="/admin/financial-dashboard"
          element={<FinancialDashboard />}
        />
        <Route
          path="/admin/batch-progress-dashboard"
          element={<AdminProgressDashboard />}
        />
        <Route
          path="/admin/course-progress-management"
          element={<AdminStepManagement />}
        />
        <Route path="/admin/register-mentor" element={<MentorRegisterPage />} />
        {/* Legacy */}
        <Route path="/admin/manage-legacy" element={<AdminLegacyPending />} />
        <Route
          path="/admin/writing-tasks"
          element={<AdminWritingTasksPage />}
        />
        <Route
          path="/admin/writing-tasks/create"
          element={<CreateWritingTaskPage />}
        />
        <Route
          path="/admin/writing-tasks/:taskId/edit"
          element={<EditWritingTaskPage />}
        />
        <Route
          path="/admin/writing-tasks/:taskId/assign"
          element={<AssignWritingTaskPage />}
        />
        <Route
          path="/admin/attendance-overview"
          element={<AdminAttendanceOverview />}
        />
        <Route
          path="/admin/regulation-review"
          element={<AdminRegulationReview />}
        />
        <Route
          path="/admin/regulation-templates"
          element={<CourseRegulationTemplates />}
        />
        <Route
          path="/admin/ausbildung-application-overview"
          element={<AdminAusbildungDashboard />}
        />
        <Route path="/admin/homework" element={<AdminHomeworkPage />} />
        <Route
          path="/admin/homework/create"
          element={<AdminCreateHomeworkPage />}
        />
        <Route
          path="/admin/homework/:homeworkId/edit"
          element={<AdminEditHomeworkPage />}
        />
        <Route
          path="/admin/homework/:homeworkId/assign"
          element={<AdminAssignHomeworkPage />}
        />
        <Route
          path="/admin/homework/:homeworkId/view"
          element={<AdminHomeworkViewPage />}
        />
        <Route
          path="/admin/vocabulary-management"
          element={<AdminVocabularyManagement />}
        />

        {/* EXAM ROUTES */}
        <Route
          path="/admin/exam-management"
          element={<AdminExamManagement />}
        />
        <Route
          path="/admin/exams/:examId/edit"
          element={<AdminEditExamSet />}
        />
        <Route path="/admin/exams/create" element={<AdminCreateExamSet />} />
        <Route
          path="/admin/exams/:examId/questions"
          element={<AdminManageQuestions />}
        />
        <Route
          path="/admin/exams/:examId/assign"
          element={<AdminAssignExam />}
        />
        <Route
          path="/admin/exams/assignments"
          element={<AdminExamAssignments />}
        />
        <Route
          path="/admin/exams/assignments/:assignmentId/grade"
          element={<AdminBatchGrading />}
        />
        <Route path="/admin/exams/results" element={<AdminExamResults />} />
        <Route path="/admin/class-test-management" element={<AdminClassTestManagement />} />
        <Route path="/admin/speaking-practice" element={<AdminAudioReviewPage />} />
        <Route
          path="/admin/exams/statistics"
          element={<AdminExamStatistics />}
        />
        <Route
          path="/admin/exams/:examId/builder"
          element={<AdminExamBuilder />}
        />
        <Route
          path="/admin/cover-letter-access"
          element={<CoverLetterAccessManagement />}
        />
        <Route
          path="/admin/cv-builder-access"
          element={<CvBuilderAccessManagement />}
        />

        {/* ✅ BLOG ADMIN ROUTES */}
        <Route path="/admin/manage-blogs" element={<AdminBlogManagement />} />
        <Route path="/admin/create-blog" element={<CreateEditBlog />} />
        <Route path="/admin/edit-blog/:id" element={<CreateEditBlog />} />
        <Route path="/admin/calendar" element={<AdminCalendarManagement />} />

        {/* SHADOWING TASK ROUTES */}
        <Route
          path="/admin/shadowing-tasks"
          element={<AdminShadowingTasksPage />}
        />
        <Route
          path="/admin/shadowing-tasks/create"
          element={<CreateShadowingTaskPage />}
        />
        <Route
          path="/admin/shadowing-tasks/:taskId/edit"
          element={<EditShadowingTaskPage />}
        />
        <Route
          path="/admin/shadowing-tasks/:taskId/assign"
          element={<AssignShadowingTaskPage />}
        />
        <Route
          path="/admin/shadowing-tasks/submissions/:submissionId/review"
          element={<ReviewShadowingSubmissionPage />}
        />
        <Route
          path="/admin/shadowing-tasks/:taskId/submissions"
          element={<AdminShadowingSubmissionsListPage />}
        />
        <Route path="/admin/monthly-visits" element={<MonthlyVisits />} />
        <Route path="/admin/activity-report" element={<AdminActivityReport />} />
        <Route path="/admin/mentor-tracker" element={<AdminMentorTracker />} />

        {/* LECTURE ROUTES */}
        <Route
          path="/admin/course-lectures"
          element={<CourseLecturesLayout />}
        />
      </Route>

      {/* MENTOR ROLE PROTECTED ROUTES */}
      <Route element={<RoleProtectedRoute allowedRoles={["MENTOR"]} />}>
        <Route path="/mentor/dashboard" element={<MentorDashboard />} />
        <Route path="/mentor/my-batches" element={<MentorBatches />} />
        <Route
          path="/mentor/manage-quizzes/:quizId/assign"
          element={<AssignQuizPage />}
        />
        <Route path="/mentor/manage-quizzes" element={<MentorManageQuiz />} />
        <Route
          path="/mentor/batch-course-progress"
          element={<MentorBatchCourseProgress />}
        />
        <Route
          path="/mentor/progress-overview"
          element={<MentorProgressDashboard />}
        />
        <Route
          path="/mentor/writing-tasks"
          element={<MentorWritingTasksPage />}
        />
        <Route
          path="/mentor/writing-tasks/:taskId/assign"
          element={<MentorAssignWritingTaskPage />}
        />
        <Route
          path="/mentor/writing-task-results"
          element={<MentorBatchWritingTaskResultsPage />}
        />
        <Route path="/mentor/homework" element={<MentorHomeworkPage />} />
        <Route
          path="/mentor/homework/:homeworkId/view"
          element={<MentorHomeworkViewPage />}
        />
        <Route
          path="/mentor/homework/:homeworkId/assign"
          element={<MentorAssignHomeworkPage />}
        />
        <Route
          path="/mentor/exam-management"
          element={<MentorExamManagement />}
        />
        <Route
          path="/mentor/class-test-management"
          element={<MentorClassTestManagement />}
        />
        <Route
          path="/mentor/exams/:assignmentId/grade"
          element={<MentorGradeExam />}
        />
        <Route
          path="/mentor/exams/:assignmentId/results"
          element={<MentorExamResults />}
        />

        {/* ✅ ADD MENTOR SHADOWING ROUTES HERE */}
        <Route
          path="/mentor/shadowing-tasks"
          element={<MentorShadowingTasksPage />}
        />
        <Route
          path="/mentor/shadowing-tasks/:taskId/assign"
          element={<MentorAssignShadowingTaskPage />}
        />
        <Route
          path="/mentor/shadowing-tasks/batch-summary"
          element={<MentorBatchShadowingTaskSummary />}
        />
        <Route
          path="/mentor/shadowing-tasks/:taskId/submissions"
          element={<MentorReviewShadowingSubmissionPage />}
        />
        <Route
          path="/mentor/shadowing-tasks/submissions/:submissionId/review"
          element={<MentorReviewShadowingSubmissionDetailPage />}
        />
        <Route path="/mentor/speaking-practice" element={<MentorAudioReviewPage />} />
        <Route path="/mentor/task-checklist" element={<MentorTaskCheckinPage />} />
      </Route>

      {/* EMPLOYEE ROLE PROTECTED ROUTES */}
      <Route element={<RoleProtectedRoute allowedRoles={["EMPLOYEE"]} />}>
        <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
      </Route>

      {/* Fallback route - MUST be last */}
      <Route path="*" element={<Navigate to="/index" replace />} />
    </Routes>
  );
};

export default ALLRoutes;
